import { useNumberOfBriefingsStore } from '@infrastructure/store';

const useIsFirstTimeUser = (): boolean => {
  const [numberOfBriefings] = useNumberOfBriefingsStore();

  return !numberOfBriefings;
};

export { useIsFirstTimeUser };
